(() => {
  const mainContent = document.getElementById('MainContent');
  if (!mainContent) return;

  const textTranslations = new Map([
    ['Track Your Order', 'Rastrea tu pedido'],
    ['Order Number', 'Número de pedido'],
    ['Tracking Number', 'Número de seguimiento'],
    ['Phone Number', 'Número de teléfono'],
    ['Email', 'Correo electrónico'],
    ['TRACK', 'RASTREAR'],
    ['Track', 'Rastrear'],
    ['Ordered', 'Pedido realizado'],
    ['Order pending', 'Pedido pendiente'],
    ['Info received', 'Información recibida'],
    ['In transit', 'En tránsito'],
    ['Available for pickup', 'Disponible para recoger'],
    ['Out for delivery', 'En reparto'],
    ['Delivered', 'Entregado'],
    ['Delivery failure', 'Entrega fallida'],
    ['Undelivered', 'No entregado'],
    ['Exception', 'Incidencia en el envío'],
    ['Expired', 'Seguimiento caducado'],
    ['Not Found', 'Seguimiento no encontrado'],
    ['Not found', 'Seguimiento no encontrado'],
    ['Not shipped yet', 'Aún no enviado'],
    ['Estimated delivery date', 'Fecha estimada de entrega'],
    ['Estimated delivery dates', 'Fechas estimadas de entrega'],
    ['Time of delivery', 'Fecha y hora de entrega'],
    ['Transit time', 'Tiempo en tránsito'],
    ['Shipped days', 'Días en tránsito'],
    ['Day', 'Día'],
    ['Days', 'Días'],
    ['Origin', 'Origen'],
    ['Destination', 'Destino'],
    ['Carrier', 'Transportista'],
    ['Carrier website', 'Web del transportista'],
    ['Telephone', 'Teléfono'],
    ['Order information', 'Información del pedido'],
    ['Product information', 'Información del producto'],
    ['Copy', 'Copiar'],
    ['Translate', 'Traducir'],
    ['Today', 'Hoy'],
    ['We are preparing your order for dispatch.', 'Estamos preparando tu pedido para enviarlo.'],
    ['Tracking Information', 'Información de seguimiento'],
    ["Tracking information isn't available yet. Please wait.", 'La información de seguimiento aún no está disponible. Espera, por favor.'],
    ['Show less', 'Mostrar menos'],
    ['Show more', 'Mostrar más'],
    ['Please enter your order number.', 'Introduce un número de pedido.'],
    ['Please enter order number.', 'Introduce el número de pedido.'],
    ['Please enter your tracking number.', 'Introduce un número de seguimiento.'],
    ['Please enter your email.', 'Introduce tu correo electrónico.'],
    ['Please enter your phone number.', 'Introduce tu número de teléfono.'],
    ['Please enter a valid email address.', 'El correo electrónico no es válido.'],
    ['Please enter a valid phone number.', 'El número de teléfono no es válido.'],
    ['No tracking information found.', 'No se ha encontrado información de seguimiento.'],
    ['Tracking Info Not Found', 'No se ha encontrado información de seguimiento'],
    [
      'Please check if the order info is correct. Unshipped orders can not be tracked.',
      'Comprueba que los datos del pedido sean correctos. Los pedidos que aún no se han enviado no se pueden rastrear.',
    ],
    ['Powered by 17TRACK', 'Con tecnología de 17TRACK'],
    ['The carrier has not provided tracking information yet.', 'El transportista todavía no ha proporcionado información.'],
    ['Loading tracking information...', 'Cargando información de seguimiento…'],
  ]);

  const attributeTranslations = new Map([
    ['Order Number', 'Número de pedido'],
    ['Tracking Number', 'Número de seguimiento'],
    ['Phone Number', 'Número de teléfono'],
    ['Email', 'Correo electrónico'],
  ]);

  const caseInsensitiveTranslations = new Map(
    [...textTranslations].map(([source, translation]) => [source.toLowerCase(), translation])
  );

  const labelTranslations = new Map([
    ['Estimated delivery date', 'Fecha estimada de entrega'],
    ['Estimated delivery dates', 'Fechas estimadas de entrega'],
    ['Time of delivery', 'Fecha y hora de entrega'],
    ['Transit time', 'Tiempo en tránsito'],
    ['Shipped days', 'Días en tránsito'],
    ['Origin', 'Origen'],
    ['Destination', 'Destino'],
    ['Carrier', 'Transportista'],
    ['Tracking Number', 'Número de seguimiento'],
    ['Order Number', 'Número de pedido'],
  ]);

  const unavailableTrackingMessages = new Set([
    "Tracking information isn't available yet. Please wait.",
    'La información de seguimiento aún no está disponible. Espera, por favor.',
  ]);

  const syncExternalTrackingFallback = (widget, messageElement) => {
    const existingFallback = widget.querySelector('[data-external-tracking-fallback]');

    if (!messageElement) {
      existingFallback?.remove();
      return;
    }

    if (existingFallback) return;

    const fallback = document.createElement('aside');
    fallback.className = 'tracking-fallback tracking-fallback--inline';
    fallback.dataset.externalTrackingFallback = '';
    fallback.setAttribute('aria-labelledby', 'tracking-external-fallback-title');

    const icon = document.createElement('span');
    icon.className = 'tracking-fallback__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = 'i';

    const content = document.createElement('div');
    content.className = 'tracking-fallback__content';

    const title = document.createElement('h2');
    title.id = 'tracking-external-fallback-title';
    title.className = 'tracking-fallback__title';
    title.textContent = '¿Aún no aparece el seguimiento?';

    const text = document.createElement('p');
    text.className = 'tracking-fallback__text';
    text.textContent = 'Consulta tu envío directamente en la web oficial de 17TRACK.';

    const link = document.createElement('a');
    link.className = 'tracking-fallback__link';
    link.href = 'https://www.17track.net/es';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.textContent = 'Abrir 17TRACK';
    link.setAttribute('aria-label', 'Abrir la web oficial de 17TRACK en una pestaña nueva');

    const arrow = document.createElement('span');
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '→';
    link.append(' ', arrow);

    content.append(title, text);
    fallback.append(icon, content, link);
    messageElement.insertAdjacentElement('afterend', fallback);
  };

  const translateText = (text) => {
    const exactTranslation = textTranslations.get(text);
    if (exactTranslation) return exactTranslation;

    const caseInsensitiveTranslation = caseInsensitiveTranslations.get(text.toLowerCase());
    if (caseInsensitiveTranslation) return caseInsensitiveTranslation;

    const packageMatch = text.match(/^Package\s+(\d+)$/i);
    if (packageMatch) return `Paquete ${packageMatch[1]}`;

    for (const [source, translation] of labelTranslations) {
      const labelPattern = new RegExp(`^${source.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\s*:`,'i');
      if (labelPattern.test(text)) return text.replace(labelPattern, `${translation}:`);
    }

    return null;
  };

  const translateWidget = () => {
    const widget = mainContent.querySelector('#__next');
    if (!widget) return;

    let unavailableMessageElement = null;
    const walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
    let textNode = walker.nextNode();
    while (textNode) {
      const originalText = textNode.nodeValue;
      const normalizedText = originalText.trim();
      if (unavailableTrackingMessages.has(normalizedText)) {
        unavailableMessageElement = textNode.parentElement;
      }
      const translation = translateText(normalizedText);
      if (translation) {
        textNode.nodeValue = originalText.replace(normalizedText, translation);
      }
      textNode = walker.nextNode();
    }

    widget.querySelectorAll('input[placeholder], input[aria-label]').forEach((input) => {
      ['placeholder', 'aria-label'].forEach((attribute) => {
        const value = input.getAttribute(attribute);
        const translation = attributeTranslations.get(value);
        if (translation) input.setAttribute(attribute, translation);
      });
    });

    syncExternalTrackingFallback(widget, unavailableMessageElement);
  };

  translateWidget();

  const observer = new MutationObserver(translateWidget);
  observer.observe(mainContent, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['placeholder', 'aria-label'],
  });
})();
